module.exports = __webpack_public_path__ + "static/media/ic_close_black.33596eff.svg";